import { Link, usePage } from '@inertiajs/react'
import { ChevronRight } from 'lucide-react'
import { forgeDestinations, forgeNavigationPath, forgeProjectId } from '@/frontend/layouts/worker-first/forgeNavigation'
import type { SharedProps } from '@/frontend/types/inertia'

export default function ContextHeader() {
  const { props, url } = usePage<SharedProps>()
  const copy = props.navigationLabels.forge
  const id = forgeProjectId(url, props.forgeAccess?.default_project_id)
  const project = props.forgeAccess?.projects.find((item) => item.id === id)
  const destination = forgeDestinations.find((item) => item.path && item.path === forgeNavigationPath(url))
  const section = /\/dashboards(?:\/|\?|$)/.test(url) ? copy.dashboards : destination ? copy[destination.key] : copy.projects
  return <header data-testid="forge-context-header" className="flex h-12 shrink-0 items-center gap-2 border-b border-border bg-background px-4 text-xs md:px-6">
    <Link href="/dashboard/discovery/projects" className="truncate text-muted-foreground hover:text-foreground">{props.auth.user?.active_organization?.name}</Link>
    {project && <><ChevronRight className="size-3 shrink-0 text-muted-foreground" /><Link href={`/dashboard/discovery/overview?project_id=${id}`} className="truncate text-muted-foreground hover:text-foreground">{project.name}</Link></>}
    <ChevronRight className="size-3 shrink-0 text-muted-foreground" /><span className="truncate font-medium">{section}</span>
  </header>
}
